import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';

import { FormFieldSectionHeadingI } from '../types';
import { FormDescription, FormTitle } from '../styles';
import RichText from '../../UI/RichText';

interface Props {
  formField: FormFieldSectionHeadingI;
}

// Elements to render on rich text
const headlineOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <FormTitle>{children}</FormTitle>,
    [BLOCKS.HEADING_1]: (_, children) => <FormTitle>{children}</FormTitle>,
    [BLOCKS.HEADING_2]: (_, children) => <FormTitle>{children}</FormTitle>,
  },
};

const descriptionOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <FormDescription>{children}</FormDescription>
    ),
    [BLOCKS.HEADING_1]: (_, children) => (
      <FormDescription>{children}</FormDescription>
    ),
    [BLOCKS.HEADING_2]: (_, children) => (
      <FormDescription>{children}</FormDescription>
    ),
  },
};

const FormSectionHeading = ({ formField }: Props) => {
  const {
    heading: { heading: header, subHeading },
  } = formField;

  return (
    <>
      <RichText document={header} options={headlineOptions} />
      <RichText document={subHeading} options={descriptionOptions} />
    </>
  );
};

export default FormSectionHeading;
